var map = {
	"./betBg.png": 808197,
	"./freecard.png": 980897,
	"./freeplay.png": 108613,
	"./freeplaybtn.png": 14561,
	"./freespin.png": 583715,
	"./freespinbtn.png": 750003,
	"./mask.png": 415741,
	"./maxbet按钮.png": 569795,
	"./select.png": 795125,
	"./selected.png": 228050,
	"./spin按钮.png": 771028,
	"./stop按钮.png": 29548,
	"./充值按钮.png": 382051,
	"./减按钮.png": 946375,
	"./加按钮.png": 826664,
	"./遮罩.png": 580358,
	"./金币图标.png": 122742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 878432;